/*
 * GoalResultContainer.jsx 21.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import getResultsByGoalQuery from '../../queries/getResultsByGoal.graphql';
import {graphql} from 'react-apollo';
import {compose} from 'redux';
import GoalResultDetailsItem from '../../components/detail/GoalResultDetailsItem';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


const withResults = graphql(getResultsByGoalQuery, {
    options: params => ({
        variables: {zielId: parseInt(params.match.params.goalId, 10)},
        fetchPolicy: 'network-only',
        pollInterval: 60000
    }),
    props: ({ownProps, data}) => {

        if (data.loading || !data.getErgebnisseByZielId) {
            return {
                goalResultsLoading: true,
                goalResults: [],
                refetchGoalResults: data.refetch
            };
        }

        if (data.error) {
            return {hasErrors: true, goalResults: []};
        }

        return {
            goalResults: data.getErgebnisseByZielId,
            refetchGoalResults: data.refetch,
            ...ownProps
        };
    }
});

const mapStateToProps = ({sort, participant}) => ({sort, participant});

export default withRouter(compose(connect(mapStateToProps, {}), withResults)(GoalResultDetailsItem));



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/detail/GoalResultContainer.js